import { render, staticRenderFns } from "./Moexbluechip.vue?vue&type=template&id=64dad47c&"
import script from "./Moexbluechip.vue?vue&type=script&lang=js&"
export * from "./Moexbluechip.vue?vue&type=script&lang=js&"
import style0 from "./Moexbluechip.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports